<template>
  <div class="static-settings">
    <div>
      <section-title>{{ $t('view.settings.statics.title') }}</section-title>
    </div>
    <div class="editor-section-description">
      {{ $t('view.settings.statics.menuDescription') }}
      <min-sel
        class="static-settings__sel-locale"
        v-model="selectedLocale"
        @change="localeChanged"
        framed
      >
        <option
          v-for="locale in $store.state.flowLocales"
          :key="locale.id"
          :value="locale.id"
        >{{ locale.name }}</option>
      </min-sel>
    </div>
    <section-title subsection>{{ $t('view.settings.statics.menu') }}</section-title>
    <div class="static-settings__section static-settings__basic-section editor-section">
      <msg-persistent class="static-settings__menu" :menu="selectedMenu"></msg-persistent>
      <div class="static-settings__buttons">
        <btn
          class="static-settings__basic-section-button"
          icon="trash"
          color="red"
          @click="disableMenu"
        >{{ $t('btn.delete') }}</btn>

        <btn
          class="static-settings__basic-section-button"
          icon="save"
          @click="saveEditedMenus"
        >{{ $t('btn.save') }}</btn>
      </div>
    </div>
    <section-title subsection>{{ $t('view.settings.statics.greeting') }}</section-title>
    <div class="static-settings__section static-settings__basic-section editor-section">
      <in :label="$t('common.text')" v-model="greetingText" @enter="saveGreeting"/>
      <div class="static-settings__buttons">
        <btn
          class="static-settings__basic-section-button"
          icon="trash"
          color="red"
          @click="disableGreeting"
        >{{ $t('btn.delete') }}</btn>

        <btn
          class="static-settings__basic-section-button"
          icon="save"
          @click="saveGreeting"
        >{{ $t('btn.save') }}</btn>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import store from '@/store'

export default {
  data() {
    return {
      menus: {},
      blocks: [],
      selectedMenu: null,
      selectedLocale: null,
      greetingText: '',
    }
  },

  mounted() {
    this.$store.dispatch('loadFlowLocales', this).then(() => {
      Object.keys(this.$store.state.flowLocales).forEach(key => {
        if (this.$store.state.flowLocales[key].default) {
          this.selectedLocale = this.$store.state.flowLocales[key].id
        }
      })
      this.fetchMenus()
    })
  },

  methods: {
    async fetchMenus() {
      try {
        let res = await axios.get('/api/elements/persistent/list')
        this.menus = {}
        for (let i = 0; i < res.data.persistentMenus.length; i++) {
          let actMenu = res.data.persistentMenus[i]
          this.menus[actMenu.flow_locales_id] = actMenu
          if (actMenu.flow_locales_id === this.selectedLocale) this.selectedMenu = actMenu
        }
      } catch (e) {
        this.notify('error', 'view.settings.error.menuLoad')
        console.error(e)
      }
    },

    localeChanged() {
      this.selectedMenu = this.menus[this.selectedLocale]
    },

    async saveEditedMenus() {
      try {
        await axios.patch('/api/elements/persistent/update', {
          persistentMenus: Object.keys(this.menus).map(o => this.menus[o])
        })
        this.notify('success', 'view.settings.success.staticSave')
      } catch (e) {
        this.notify('error', 'view.settings.error.staticSave')
        console.error(e)
      }
    },

    async disableMenu() {
      try {
        await axios.delete('/api/elements/persistent/disable')
        this.notify('success', 'view.settings.success.staticDisable')
      } catch (e) {
        this.notify('error', 'view.settings.error.staticDisable')
        console.error(e)
      }
    },

    async saveGreeting() {
      try {
        await axios.post('/api/elements/greeting/set', {
          text: this.greetingText
        })
        this.notify('success', 'view.settings.success.staticSave')
      } catch (e) {
        this.notify('error', 'view.settings.error.staticSave')
        console.error(e)
      }
    },

    async disableGreeting() {
      try {
        await axios.post('/api/elements/greeting/disable')
        this.notify('success', 'view.settings.success.staticDisable')
      } catch (e) {
        this.notify('error', 'view.settings.error.staticDisable')
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss">
.static-settings {
  &__section {
    margin-bottom: 80px;
    position: relative;
    width: 34vw;
    min-width: 540px;
  }

  &__basic-section {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  &__sel-locale {
    width: 110px;
    margin-top: 12px;
  }

  &__basic-section-button {
    margin-left: 10px;
  }

  &__buttons {
    position: absolute;
    top: calc(100% + 18px);
    right: 0;
  }
}
</style>
